// Barra sticky de cambios sin guardar (`.save-bar` del mock) con Descartar y Guardar. Se oculta
// con count = 0. La usan los editores inline: configuración, políticas, promociones, reglas.
import { Button } from '@/kit';
import { cn } from '@/lib/cn';

export function SaveBar({
    count,
    message,
    saving = false,
    saveLabel = 'Guardar cambios',
    saveDisabled = false,
    onDiscard,
    onSave,
    className,
}: {
    /** Cambios sin guardar; con 0 la barra no se renderiza. */
    count: number;
    /** Mensaje custom; default "N cambio(s) sin guardar". */
    message?: string;
    saving?: boolean;
    /** Texto del botón principal; p. ej. «Guardar y publicar» cuando guardar también publica. */
    saveLabel?: string;
    /** El botón principal apagado: falta algo que no es un campo del formulario. */
    saveDisabled?: boolean;
    onDiscard: () => void;
    onSave: () => void;
    className?: string;
}) {
    if (count === 0) return null;
    const defaultMessage =
        count === 1 ? '1 cambio sin guardar' : `${String(count)} cambios sin guardar`;
    return (
        <div
            className={cn(
                'sticky bottom-0 flex items-center justify-between gap-3 border-t border-info/30 bg-info/10 px-3 py-2 backdrop-blur',
                className,
            )}
        >
            <span className="text-[11px] font-semibold text-info">{message ?? defaultMessage}</span>
            <div className="flex gap-1.5">
                <Button variant="ghost" size="sm" onClick={onDiscard} disabled={saving}>
                    Descartar
                </Button>
                <Button size="sm" onClick={onSave} isLoading={saving} disabled={saveDisabled}>
                    {saveLabel}
                </Button>
            </div>
        </div>
    );
}

export type SaveBarProps = Parameters<typeof SaveBar>[0];
